export interface AuthUser {
    id: number | null;
    displayName: string | null;
}

export interface AuthSession {
    authenticated: boolean;
    user: AuthUser;
    nonce: string | null;
}

const jsonHeaders = {"Content-Type": "application/json"};

export async function login(username: string, password: string): Promise<void> {
    const response = await fetch("/auth/login", {
        method: "POST",
        credentials: "same-origin",
        headers: jsonHeaders,
        body: JSON.stringify({username, password})
    });

    if (!response.ok) {
        const data = await response.json().catch(() => null);
        throw new Error(data?.message || "Login failed");
    }
}

export async function fetchAuthSession(offerId?: string): Promise<AuthSession> {
    const query = offerId ? `?offerId=${encodeURIComponent(offerId)}` : "";
    const response = await fetch(`/auth/session${query}`, {
        credentials: "same-origin",
        headers: {Accept: "application/json"}
    });

    if (!response.ok) {
        throw new Error(response.status === 401 ? "Brak autoryzacji !" : "Nie udało się sprawdzić sesji");
    }

    return response.json();
}

export async function logout(): Promise<void> {
    const response = await fetch("/auth/logout", {
        method: "POST",
        credentials: "same-origin",
        headers: jsonHeaders
    });

    if (!response.ok && response.status !== 204) {
        throw new Error("Logout failed");
    }
}
